<admin-app-header></admin-app-header>

<div class="emails-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div>
                <h1>Emails</h1>
                <p class="page-subtitle" *ngIf="!loading">{{ logEmails.length }} emails loaded</p>
            </div>
        </div>

        <!-- Stats Cards -->
        <div class="stats-grid" *ngIf="!loading">
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-envelope"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Emails</span>
                    <span class="stat-card__value">{{ logEmails.length }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--orange">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-flag"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Needs Review</span>
                    <span class="stat-card__value">{{ getNeedsReviewCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-filter"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Showing</span>
                    <span class="stat-card__value">{{ filteredEmails.length }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar" *ngIf="!loading">
            <div class="filter-bar__left">
                <div class="filter-search">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text"
                           class="filter-input"
                           placeholder="Search by email address, subject, or content..."
                           [(ngModel)]="searchTerm"
                           (input)="onSearchChange()" />
                    <button class="filter-clear" *ngIf="searchTerm" (click)="clearSearch()">
                        <i class="fa-solid fa-times"></i>
                    </button>
                </div>
                <div class="status-toggle">
                    <button class="toggle-btn"
                            [class.active]="filterType === 'all'"
                            (click)="onFilterTypeChange('all')">
                        All
                    </button>
                    <button class="toggle-btn"
                            [class.active]="filterType === 'needs-review'"
                            (click)="onFilterTypeChange('needs-review')">
                        Needs Review
                    </button>
                </div>
            </div>
            <div class="filter-bar__right">
                <select class="items-select" [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
                    <option [ngValue]="200">200 per page</option>
                    <option [ngValue]="500">500 per page</option>
                    <option [ngValue]="1000">1000 per page</option>
                </select>
                <span class="results-count">{{ filteredEmails.length }} results</span>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <h3>Loading Emails</h3>
            <p>Fetching all emails...</p>
        </div>

        <!-- Empty State (no emails at all) -->
        <div class="empty-state" *ngIf="!loading && logEmails.length === 0">
            <i class="fa-solid fa-envelope"></i>
            <h3>No Emails Found</h3>
            <p>There are no logged emails to display.</p>
        </div>

        <!-- No matching results after filtering -->
        <div class="empty-state" *ngIf="!loading && logEmails.length > 0 && filteredEmails.length === 0">
            <i class="fa-solid fa-search"></i>
            <h3>No Matching Emails</h3>
            <p>No emails match your search for "{{ searchTerm }}". Try adjusting your search.</p>
            <button class="btn btn-primary" (click)="clearSearch()">
                <i class="fa-solid fa-times"></i> Clear Search
            </button>
        </div>

        <!-- Emails Table -->
        <div class="table-card" *ngIf="!loading && filteredEmails.length > 0">
            <table class="emails-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>To</th>
                        <th>Subject</th>
                        <th class="content-col">Content</th>
                        <th>Merchant</th>
                        <th>Client</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let logEmail of getPaginatedEmails(); trackBy: trackByEmailKey"
                        [class.needs-review]="logEmail.needsReview"
                        class="email-row">
                        <td class="date-cell">
                            {{ logEmail.createdAt | daysAgo }}
                        </td>
                        <td class="to-cell">
                            <div class="email-recipients">
                                <span *ngFor="let email of logEmail.toEmails" class="email-badge" title="{{ email }}">
                                    {{ email }}
                                </span>
                                <span *ngIf="!logEmail.toEmails || logEmail.toEmails.length === 0" class="text-muted">N/A</span>
                            </div>
                        </td>
                        <td>
                            <a [routerLink]="['/admin/email', logEmail.$key]" class="subject-link">
                                {{ logEmail.subject }}
                            </a>
                        </td>
                        <td class="content-col">
                            <span class="content-preview" title="{{ logEmail.content }}">
                                {{ logEmail.content | stripHtml | truncate: [120] }}
                            </span>
                        </td>
                        <td>
                            <span *ngIf="logEmail.merchantRef" class="badge bg-success">Yes</span>
                            <span *ngIf="!logEmail.merchantRef" class="text-muted">No</span>
                        </td>
                        <td>
                            <span *ngIf="logEmail.clientRef" class="badge bg-success">Yes</span>
                            <span *ngIf="!logEmail.clientRef" class="text-muted">No</span>
                        </td>
                        <td>
                            <div class="action-buttons">
                                <a [routerLink]="['/admin/email', logEmail.$key]"
                                   class="btn btn-outline-primary btn-sm"
                                   title="View email details">
                                    <i class="fa-solid fa-eye"></i>
                                </a>
                                <button class="btn btn-sm"
                                        [class.btn-outline-warning]="!logEmail.needsReview"
                                        [class.btn-warning]="logEmail.needsReview"
                                        (click)="onNeedsReview(logEmail)"
                                        [title]="logEmail.needsReview ? 'Remove review flag' : 'Flag for review'">
                                    <i class="fa-solid fa-flag"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="pagination-wrapper" *ngIf="!loading && filteredEmails.length > 0 && totalPages > 1">
            <div class="pagination-info">
                Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to {{ Math.min(currentPage * itemsPerPage, totalItems) }} of {{ totalItems }} emails
            </div>
            <div class="pagination">
                <button class="page-btn" (click)="goToPage(1)" [disabled]="currentPage === 1" title="First page">
                    <i class="fa-solid fa-angles-left"></i>
                </button>
                <button class="page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" title="Previous page">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
                <button *ngFor="let page of getPageNumbers()"
                        class="page-btn"
                        [class.active]="page === currentPage"
                        (click)="goToPage(page)">
                    {{ page }}
                </button>
                <button class="page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" title="Next page">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
                <button class="page-btn" (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages" title="Last page">
                    <i class="fa-solid fa-angles-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>
